export type TMapTile = {
    Terrain: ETerrainTypes;
}

export type TDisplayMapTile = TMapTile & {
    TownIndex: number| undefined;
    ChaserIndexes: number[];
}

export enum ETerrainTypes {Desert, Plains, Mountains, Hills}

export const mapTerrainColors: { [key in ETerrainTypes]: string } = {
    [ETerrainTypes.Desert]: "rgba(210, 180, 140, 0.5)",
    [ETerrainTypes.Plains]: "rgba(162, 195, 121, 0.5)",
    [ETerrainTypes.Mountains]: "rgba(139, 125, 123, 0.5)",
    [ETerrainTypes.Hills]: "rgba(176, 162, 126, 0.5)",
};
  
export type TLocation= {
    x: number;
    y: number;
}